import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const GetCustomerParents = graphql(`
  query GetCustomerParentsByUserId($userId: String!) {
    customer(identifier: $userId) {
      __typename
      ... on Customer {
        identifier
        parents {
          type
          identifier
        }
      }
      ... on BasicError {
        errorName
        message
      }
      ... on UnknownError {
        errorName
        message
      }
    }
  }
`);
